export default function lineChart({ loader, chartData, label, header }) {
  let noData = true;
  chartData?.series?.forEach((series) => {
    series?.data?.forEach((data) => {
      if (noData) {
        noData = data == null;
      }
    });
  });
  const chart = {
    title: {
      text:
        !loader && noData
          ? `No Data available for ${chartData?.title} `
          : chartData.title,
      left: noData ? "center" : "left",
      top: noData ? "center" : "top",
      textStyle: {
        color: "#777",
        fontSize: "13px",
        fontFamily: "Montserrat Bold",
        overflow: "break",
        width: noData ? 200 : 400,
      },
    },
    tooltip: {
      trigger: "axis",
      order: "seriesDesc",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985",
        },
      },
    },
    legend: {
      data: noData ? [] : label,
      orient: "vertical",
      left: "right",
      top: "top",
      icon: "circle",
      padding: [0, 50, 10, 0],
      textStyle: {
        color: "#777",
        fontFamily: "Montserrat Regular",
        fontSize: "10px",
      },
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: noData ? [] : chartData?.xAxis?.data,
        axisLine: {
          show: noData ? false : true,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: "{value}",
        },
      },
      {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#118AB2",
          },
        },
        axisLabel: {
          formatter: "{value}",
        },
      },
    ],
    series: [
      {
        symbol: "circle",
        symbolSize: 8,
        itemStyle: { color: "#118AB2" },
        name: label[1],
        yAxisIndex: 1,
        type: "line",
        lineStyle: {
          color: "#118AB2",
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(17,138,178,100%)", // color at 0% position
              },
              {
                offset: 0.2,
                color: "rgba(17,138,178,80%)", // color at 0% position
              },
              {
                offset: 0.4,
                color: "rgba(17,138,178,60%)", // color at 0% position
              },
              {
                offset: 0.6,
                color: "rgba(17,138,178,40%)", // color at 0% position
              },
              {
                offset: 0.8,
                color: "rgba(17,138,178,20%)", // color at 0% position
              },
            ],
          },
        },
        emphasis: {
          focus: "series",
        },
        data: chartData?.series[1]?.data,
      },
      {
        symbol: "circle",
        symbolSize: 8,
        itemStyle: { color: "#118AB2" },
        name: label[0],
        yAxisIndex: 1,
        type: "line",
        lineStyle: {
          color: "#118AB2",
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(17,138,178,100%)", // color at 0% position
              },
              {
                offset: 0.2,
                color: "rgba(17,138,178,80%)", // color at 0% position
              },
              {
                offset: 0.4,
                color: "rgba(17,138,178,60%)", // color at 0% position
              },
              {
                offset: 0.6,
                color: "rgba(17,138,178,40%)", // color at 0% position
              },
              {
                offset: 0.8,
                color: "rgba(17,138,178,20%)", // color at 0% position
              },
            ],
          },
        },
        emphasis: {
          focus: "series",
        },
        data: chartData?.series[0]?.data,
      },
    ],
  };
  return chart;
}
